import React from 'react';
import Translate from "../../../components/Translate";
import Tooltip from "../../general/Tooltip";
import InfoIcon from "../../../assets/icons/InfoIcon";
import Colors from "../../../utils/Colors";
import './styles.css';

/**
 * Card for one setting: a short title, an optional hint icon carrying the long
 * explanation, and the control itself.
 *
 * The long text belongs on the icon, not in the heading. A settings screen whose
 * every block opens with a paragraph reads as a wall of prose, and the reader has
 * to finish a sentence before they can tell whether the block is the one they
 * came for.
 *
 * @param toggle the switch that turns the whole card on and off, placed at the
 *   far end of the heading. It used to sit inside the body under the label
 *   "Enable / Disable" - a caption that says nothing, since every switch enables
 *   and disables - and being in the body it read as one setting among the
 *   others rather than as the power of all of them.
 * @param dimmed the setting is overridden by another one and cannot take effect
 *   right now. It stays readable, because it is still the company's choice.
 */
const SettingCard = ({titleKey, hintKey, toggle, dimmed = false, children}) => (
    <section className={'setting-card' + (dimmed ? ' setting-card--dimmed' : '')}>
        <div className="setting-card__head">
            <div className="setting-card__heading">
                <h3 className="setting-card__title"><Translate text={titleKey}/></h3>

                {hintKey && (
                    <Tooltip text={hintKey} inRightSide style={{display: 'flex'}}>
                        <span className="setting-card__hint">
                            <InfoIcon width={16} height={16} style={{color: Colors.silverBlueLite}} stroke="currentColor"/>
                        </span>
                    </Tooltip>
                )}
            </div>

            {toggle && <div className="setting-card__toggle">{toggle}</div>}
        </div>

        {children}
    </section>
);

export default SettingCard;



// WEBPACK FOOTER //
// ./src/components-new/ui/SettingCard/index.jsx